module.exports = require('../../full/array/from');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/array/from.js
// module id = 545
// module chunks = 0 1